import api from './api';

/** Clasificación de activos (categoría → subcategoría → familia). Rutas bajo /activos/. */
const activoClassificationService = {
  async getCategories(params = {}) {
    const response = await api.get('/activos/categories', { params });
    return response.data;
  },
  async getCategory(id) {
    const response = await api.get(`/activos/categories/${id}`);
    return response.data;
  },
  async createCategory(data) {
    const response = await api.post('/activos/categories', data);
    return response.data;
  },
  async updateCategory(id, data) {
    const response = await api.put(`/activos/categories/${id}`, data);
    return response.data;
  },
  async deleteCategory(id) {
    const response = await api.delete(`/activos/categories/${id}`);
    return response.data;
  },
  async getSubcategories(params = {}) {
    const response = await api.get('/activos/subcategories', { params });
    return response.data;
  },
  async getSubcategory(id) {
    const response = await api.get(`/activos/subcategories/${id}`);
    return response.data;
  },
  async createSubcategory(data) {
    const response = await api.post('/activos/subcategories', data);
    return response.data;
  },
  async updateSubcategory(id, data) {
    const response = await api.put(`/activos/subcategories/${id}`, data);
    return response.data;
  },
  async deleteSubcategory(id) {
    const response = await api.delete(`/activos/subcategories/${id}`);
    return response.data;
  },
  async getFamilies(params = {}) {
    const response = await api.get('/activos/families', { params });
    return response.data;
  },
  async getFamily(id) {
    const response = await api.get(`/activos/families/${id}`);
    return response.data;
  },
  async createFamily(data) {
    const response = await api.post('/activos/families', data);
    return response.data;
  },
  async updateFamily(id, data) {
    const response = await api.put(`/activos/families/${id}`, data);
    return response.data;
  },
  async deleteFamily(id) {
    const response = await api.delete(`/activos/families/${id}`);
    return response.data;
  },
  async getHierarchy(params = {}) {
    const response = await api.get('/activos/hierarchy', { params });
    return response.data;
  },
  async getFormData(params = {}) {
    const response = await api.get('/activos/form-data', { params });
    return response.data;
  },
};

export default activoClassificationService;
